import cx from "classnames";
import React, { useState, useEffect } from "react";
import { TabContent, TabPane } from "reactstrap";
import s from "../_ProductConfigurator/ProductConfiguratorComponent.module.scss";

export const TabCard = ({
  label,
  tabs,
  container,
  hasInputsAndNotModal,
  activeTabOverride,
  hasNoInputProd,
}) => {
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    // reset tactive tab if another instance is rendered
    if (activeTabOverride !== undefined) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setActiveTab(activeTabOverride);
    }
  }, [activeTabOverride]);

  return (
    <>
      {label && <h5>{label}</h5>}
      <div className={cx(s.resultsTable, "text-center")}>
        {tabs.map((tabLabel, index) => (
          <div
            key={index}
            onClick={() => setActiveTab(index + 1)}
            className={cx(s.navItem, "w-100", {
              [s.active]: index === activeTab - 1,
            })}
          >
            {hasNoInputProd ? (
              <h5 className=" px-4 text20 mb-0">{tabLabel}</h5>
            ) : (
              <div>{tabLabel}</div>
            )}
          </div>
        ))}
      </div>
      <TabContent
        activeTab={activeTab}
        className={cx("p-3 pt-0 h-100", {
          "overflow-auto": hasInputsAndNotModal || hasNoInputProd,
          [s.mediaModal]: hasNoInputProd,
        })}
      >
        {container.map((element, index) => (
          <TabPane
            key={index}
            tabId={index + 1}
            className={cx(
              "d-flex flex-column justify-content-start align-items-center",
              {
                "h-100": index + 1 === activeTab,
              },
            )}
          >
            {index + 1 === activeTab && element}
          </TabPane>
        ))}
      </TabContent>
    </>
  );
};
